export class Account {
    constructor(
        public OrgCode: string,
        public Name: string,
        public FortifyEnabled: boolean,
        public RoleId?: number
        ) {}
}
